import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import permissions from './Components/Layout/Resources/Example.json'
import AppLayout from './Views/Layout/Layout'
import Login from './Components/Auth/Login/Login'
import NotFound from './Components/PageError/NotFound/NotFound'
import Helpers from './Components/Helpers/Helpers'
import TypeMoney from './Views/TypeMoney/TypeMoney'
import Country from './Views/Country/Country'
import BranchOffice from './Views/BranchOffice/BranchOffice'
import TypeRound from './Views/TypeRound/TypeRound'
import Tax from './Views/Tax/Tax'
import Bank from './Views/Bank/Bank'
import TypeFormatPay from './Views/TypeFormatPay/TypeFormatPay'
import Language from './Views/Language/Language'
import Customers from './Views/Customers/Customers'
import TypePrice from './Views/TypePrice/TypePrice'
import TypeFormatPrint from './Views/TypeFormatPrint/TypeFormatPrint'
import Clasification from './Views/Clasification/Clasification'
import Product from './Views/Product/Product'
import Exempt from './Views/Exempt/Exempt'
/* import Component from './Views/Component/Component' */
import TypeDocument from './Views/TypeDocument/TypeDocument'
import Document from './Views/Document/Document'
import Inventory from './Views/Inventory/Inventory'
import Dashboard from './Views/Dashboard/Dashboard'
import Period from './Views/Period/Period'
import Ecommerce from './Views/Ecommerce/Ecommerce'
import Cart from './Views/Ecommerce/Cart'
import PaymentSuccess from './Views/Payment/PaymentSuccess'
import { useSelector } from 'react-redux'
import PersonalInformation from './Views/PersonaInformation/PersonalInformation'
import Red from './Views/Red/Red'
import Commissions from './Views/Red/Commissions'
import HistorySale from './Views/Report/HistorySale'
import Profile from './Views/Profile/Profile'
import Worker from './Views/Worker/Worker'
import Exchange from './Views/Exchange/Exchange'
import Promo from './Views/Promo/Promo'
import CopyProducts from './Views/BranchOffice/CopyProducts'
import ImagesSystem from './Views/Images/ImagesSystem'
import ClosePeriod from './Views/Period/ClosePeriod'
import SaleTotalBranchOffice from './Views/Report/SaleTotalBranchOffice'
import SaleProductsQtyPrice from './Views/Report/SaleProductsQtyPrice'
import CustomersNew from './Views/Report/CustomersNew'
import ReporteRed from './Views/Report/ReporteRed'
import ReporteSaleCustomers from './Views/Report/ReporteSaleCustomers'
import File from './Views/File/File'
import FilePublic from './Views/File/FilePublic'
import BreakBoxUser from './Views/Report/BreakBoxUser'
import BreakBoxBranchOffice from './Views/Report/BreakBoxBranchOffice'
import Limit from './Views/Limit/Limit'
import CommisonsPeriod from './Views/Report/CommisonsPeriod'
import CustomersAddress from './Views/CustomersAddress/CustomersAddress'
import PointPeriod from './Views/Report/PointPeriod'
import HistoryCommisions from './Views/Report/HistoryCommisions'
import Dispatch from './Views/Dispatch/Dispatch'
import CustomersPoint from './Views/Report/CustomersPoint'
import CustomersList from './Views/Report/CustomersList'
import SaveMyCustomers from './Views/Customers/SaveMyCustomers'
import PalletStock from './Views/PalletStock/PalletStock'
import RollOver from './Views/Red/RollOver'
import CustomersBono from './Views/Report/CustomersBono'
import PeriodBono from './Views/Report/PeriodBono'
import CustomersHistoryPlan from './Views/Report/CustomersHistoryPlan'
import Kardex from './Views/Report/Kardex'
import ReporteInventario from './Views/Report/ReporteInventario'
import CustomerPaid from './Views/Report/CustomerPaid'
import HistoryPaid from './Views/Report/HistoryPaid'
import CustomersPromo from './Views/Report/CustomersPromo'
import MyCustomersNew from './Views/Report/MyCustomersNew'
import ReportePromos from './Views/Report/ReportePromos'
import ReporteCedea from './Views/Report/ReporteCedea'
import SaleTracker from './Views/SaleTracker/SaleTracker'
import ReporteVentas from './Views/Report/ReporteVentas'
import EcommercePublic from './Views/Ecommerce/EcommercePublic'
import CartPublic from './Views/Ecommerce/CartPublic'
import AppLayoutPublic from './Views/Layout/LayoutPublic'
import ReporteEcommercePublico from './Views/Report/ReporteEcommercePublico'
import ReporteProductoClave from './Views/Report/ReporteProductoClave'
import Encuesta1 from './Views/Encuesta/Encuesta1'
import Encuesta1List from './Views/Encuesta/Encuesta1List'
import Encuesta2 from './Views/Encuesta/Encuesta2'
import Encuesta2List from './Views/Encuesta/Encuesta2List'
import SaleTest from './Views/Sale/SaleTest'
import FacturamaGlobal from './Views/Report/FacturamaGlobal'
import CustomersPublico from './Views/Customers/CustomersPublico'
import CustomersPublicoMessages from './Views/Customers/CustomersPublicoMessages'
import ReportePiezasNoProducidas from './Views/Report/ReportePiezasNoProducidas'
import FacturaLibre from './Views/Report/FacturaLibre'
import Viaticos from './Views/Viaticos/Viaticos'
import ViaticosAll from './Views/Viaticos/ViaticosAll'
import ReporteFacturamaFolio from './Views/Report/ReporteFacturamaFolio'
import ReporteDetalladoPeriodo from './Views/Report/ReporteDetalladoPeriodo'
import Susbcriptions from './Views/Susbcriptions/Susbcriptions'
import BreakBoxRequestEachHour from './Views/BreakBox/BreakBoxRequestEachHour'
import BreakBoxUserDaily from './Views/Report/BreakBoxUserDaily'
import BotLeads from './Views/Report/BotLeads'
import Attendance from './Views/Attend/Attendance'
import Employee from './Views/Employee/Employee'
import EmployeeReport from './Views/Employee/EmployeeReport'
import Supplier from './Views/Supplier/Supplier'
import SupplierRequest from './Views/Supplier/SupplierRequest'
import CampamentoLideres from './Views/Report/CampamentoLideres'
import RankUp from './Views/Report/RankUp'
import RecoveryPassword from './Components/Auth/Login/RecoveryPassword'
import ServicePayment from './Views/ServicePayment/ServicePayment';
import DashboardAccount from './Views/Dashboard/DashboardAccount'
import Vacation from './Views/Vacation/Vacation'
import VacationApprove from './Views/Vacation/VacationApprove'
import SmsCampaign from './Views/sms-campaign/SmsCampaign'
import BotPreOrders from './Views/Bot/BotPreOrders'

const Routes = ({ type }) => {

  const store = useSelector(store => store)

  const hasPermission = (page) => {
    let permissions = store.session.permissions || []

    let has = false

    permissions.forEach(tpm => {
      if (has) {
        return false
      }

      tpm.childrens.forEach(tp => {
        if (has) {
          return false
        }

        tp.childrens.forEach(tp => {
          if (has) {
            return false
          }

          if (tp.a_href === page) {
            has = true
          }
        })
      })
    })

    return has
  }

  const firstPermittedPage = (() => {
    for (const group of (store.session.permissions || [])) {
      for (const section of group.childrens) {
        const item = section.childrens.find(permission => permission.a_href)
        if (item) return item.a_href
      }
    }
    return ''
  })()
  const homePage = hasPermission(store.session.main_profile) ? store.session.main_profile : firstPermittedPage

  if (type === 'auth') {
    return <BrowserRouter>
      <Switch>
        <Route path={Helpers.config.convertUrl({ url: '/page/encuesta/1' })}>
          <Encuesta1 />
        </Route>
        <Route path={Helpers.config.convertUrl({ url: '/page/encuesta/2' })}>
          <Encuesta2 />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/login/empresariosindependientes' })}>
          <Login type={'empresariosindependientes'} />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/login' })}>
          <Login />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/ecommerce-publico/:idCustomers/carrito/success' })}>
          <AppLayoutPublic type="ecommerce_publico">
            <PaymentSuccess buttonReturn buttonHistory={false} />
          </AppLayoutPublic>
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/ecommerce-publico/:idCustomers/carrito/:type?' })}>
          <CartPublic />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/ecommerce-publico/:idCustomers' })}>
          <EcommercePublic />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/alta-de-cliente/:type' })}>
          <CustomersPublicoMessages />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/alta-de-cliente' })}>
          <CustomersPublico />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/alta-de-cliente/upline/:id_customers' })}>
          <CustomersPublico />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/recuperar-contrasena/:token' })}>
          <RecoveryPassword />
        </Route>
        <Route exact path={Helpers.config.convertUrl({ url: '/' })}>
          <Login />
        </Route>
        <Route>
          <Redirect to={Helpers.config.convertUrl({ url: '/login/empresariosindependientes' })} />
        </Route>
      </Switch>
    </BrowserRouter>
  }

  console.log('store.session.needs_break_box', store.session.needs_break_box)
  console.log('store.session.break_box_saved', store.session.break_box_saved)
  return <BrowserRouter>
    {store.session.needs_break_box && <BreakBoxRequestEachHour requestNow={!store.session.break_box_saved} />}
    <Switch>
      <Route path={Helpers.config.convertUrl({ url: '/page/encuesta/1' })}>
        <Encuesta1 />
      </Route>
      <Route path={Helpers.config.convertUrl({ url: '/page/encuesta/2' })}>
        <Encuesta2 />
      </Route>
      <Route exact path={Helpers.config.convertUrl({ url: '/ecommerce-publico/:idCustomers/carrito/success' })}>
        <AppLayoutPublic type="ecommerce_publico">
          <PaymentSuccess buttonReturn buttonHistory={false} />
        </AppLayoutPublic>
      </Route>
      <Route exact path={Helpers.config.convertUrl({ url: '/ecommerce-publico/:idCustomers/carrito/:type?' })}>
        <CartPublic />
      </Route>
      <Route exact path={Helpers.config.convertUrl({ url: '/ecommerce-publico/:idCustomers' })}>
        <EcommercePublic />
      </Route>
      <Route exact path={Helpers.config.convertUrl({ url: '/alta-de-cliente/:type' })}>
        <CustomersPublicoMessages />
      </Route>
      <Route exact path={Helpers.config.convertUrl({ url: '/alta-de-cliente' })}>
        <CustomersPublico />
      </Route>
      <Route exact path={Helpers.config.convertUrl({ url: '/alta-de-cliente/upline/:id_customers' })}>
        <CustomersPublico />
      </Route>
      {hasPermission('monedas') ? <Route path={Helpers.config.convertUrl({ url: '/monedas' })} exact>
        <AppLayout title="Listado De Monedas" permissions={permissions} page="monedas">
          <TypeMoney nameSingle={Helpers.string.toCamelCase('Moneda')} namePlural={Helpers.string.toCamelCase('Monedas')} separator={'La'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('paises') ? <Route path={Helpers.config.convertUrl({ url: '/paises' })} exact>
        <AppLayout title="Listado De Paises" permissions={permissions} page="paises">
          <Country nameSingle={Helpers.string.toCamelCase('País')} namePlural={Helpers.string.toCamelCase('Paises')} separator={'El'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('sucursales') ? <Route path={Helpers.config.convertUrl({ url: '/sucursales' })} exact>
        <AppLayout title="Listado De Sucursales" permissions={permissions} page="sucursales">
          <BranchOffice nameSingle={Helpers.string.toCamelCase('Sucursal')} namePlural={Helpers.string.toCamelCase('Sucursales')} separator={'La'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('redondeos') ? <Route path={Helpers.config.convertUrl({ url: '/redondeos' })} exact>
        <AppLayout title="Listado De Redondeos" permissions={permissions} page="redondeos">
          <TypeRound nameSingle={Helpers.string.toCamelCase('Redondeo')} namePlural={Helpers.string.toCamelCase('Redondeos')} separator={'El'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('impuestos') ? <Route path={Helpers.config.convertUrl({ url: '/impuestos' })} exact>
        <AppLayout title="Listado De Impuestos" permissions={permissions} page="impuestos">
          <Tax nameSingle={Helpers.string.toCamelCase('Impuesto')} namePlural={Helpers.string.toCamelCase('Impuestos')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('bancos') ? <Route path={Helpers.config.convertUrl({ url: '/bancos' })} exact>
        <AppLayout title="Listado De Bancos" permissions={permissions} page="bancos">
          <Bank nameSingle={Helpers.string.toCamelCase('Bancos')} namePlural={Helpers.string.toCamelCase('Banco')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('formatos-de-pago') ? <Route path={Helpers.config.convertUrl({ url: '/formatos-de-pago' })} exact>
        <AppLayout title="Listado De Formatos De Pago" permissions={permissions} page="formatos-de-pago">
          <TypeFormatPay nameSingle={Helpers.string.toCamelCase('Formato de Pago')} namePlural={Helpers.string.toCamelCase('Formatos de Pago')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('clientes') ? <Route path={Helpers.config.convertUrl({ url: '/clientes' })} exact>
        <AppLayout title="Listado De Clientes" permissions={permissions} page="clientes">
          <Customers nameSingle={Helpers.string.toCamelCase('Cliente')} namePlural={Helpers.string.toCamelCase('Clientes')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('idiomas') ? <Route path={Helpers.config.convertUrl({ url: '/idiomas' })} exact>
        <AppLayout title="Listado De Idiomas" permissions={permissions} page="idiomas">
          <Language nameSingle={Helpers.string.toCamelCase('Idioma')} namePlural={Helpers.string.toCamelCase('Idiomas')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('tipos-de-precio') ? <Route path={Helpers.config.convertUrl({ url: '/tipos-de-precio' })} exact>
        <AppLayout title="Listado De Precios" permissions={permissions} page="tipos-de-precio">
          <TypePrice nameSingle={Helpers.string.toCamelCase('Tipo De Precio')} namePlural={Helpers.string.toCamelCase('Tipos De Precio')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('formatos-de-ticket') ? <Route path={Helpers.config.convertUrl({ url: '/formatos-de-ticket' })} exact>
        <AppLayout title="Listado De Formatos De Ticket" permissions={permissions} page="formatos-de-ticket">
          <TypeFormatPrint nameSingle={Helpers.string.toCamelCase('Formato De Ticket')} namePlural={Helpers.string.toCamelCase('Formatos De Ticket')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('clasificaciones') ? <Route path={Helpers.config.convertUrl({ url: '/clasificaciones' })} exact>
        <AppLayout title="Listado De Clasificaciones" permissions={permissions} page="clasificaciones">
          <Clasification nameSingle={Helpers.string.toCamelCase('Clasificación')} namePlural={Helpers.string.toCamelCase('Clasificaciones')} separator={'la'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('productos') ? <Route path={Helpers.config.convertUrl({ url: '/productos' })} exact>
        <AppLayout title="Listado De Productos" permissions={permissions} page="productos">
          <Product nameSingle={Helpers.string.toCamelCase('Producto')} namePlural={Helpers.string.toCamelCase('Productos')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('excentos') ? <Route path={Helpers.config.convertUrl({ url: '/excentos' })} exact>
        <AppLayout title="Listado De Excentos" permissions={permissions} page="excentos">
          <Exempt nameSingle={Helpers.string.toCamelCase('Excento')} namePlural={Helpers.string.toCamelCase('Excentos')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {/* <Route path={Helpers.config.convertUrl({ url: '/componentes' })} exact>
        <AppLayout title="Listado De Componentes" permissions={permissions} page="componentes">
          <Component nameSingle={Helpers.string.toCamelCase('Componente')} namePlural={Helpers.string.toCamelCase('Componentes')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> */}
      {hasPermission('tipos-de-documento') ? <Route path={Helpers.config.convertUrl({ url: '/tipos-de-documento' })} exact>
        <AppLayout title="Listado De Tipos De Documento" permissions={permissions} page="tipos-de-documento">
          <TypeDocument nameSingle={Helpers.string.toCamelCase('Tipo De Documento')} namePlural={Helpers.string.toCamelCase('Tipos De Documento')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('documentos') ? <Route path={Helpers.config.convertUrl({ url: '/documentos' })} exact>
        <AppLayout title="Listado De Documentos" permissions={permissions} page="documentos">
          <Document nameSingle={Helpers.string.toCamelCase('Documento')} namePlural={Helpers.string.toCamelCase('Documentos')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('inventario') ? <Route path={Helpers.config.convertUrl({ url: '/inventario' })} exact>
        <AppLayout title="Listado De Inventarios" permissions={permissions} page="inventario">
          <Inventory nameSingle={Helpers.string.toCamelCase('Inventario')} namePlural={Helpers.string.toCamelCase('Inventarios')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ventas') ? <Route path={Helpers.config.convertUrl({ url: '/ventas' })} exact>
        <AppLayout title="Listado De Ventas" permissions={permissions} page="ventas">
          <SaleTest nameSingle={Helpers.string.toCamelCase('Venta')} namePlural={Helpers.string.toCamelCase('Ventas')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('dashboard') ? <Route path={Helpers.config.convertUrl({ url: '/dashboard' })} exact>
        <AppLayout title="Dashboard" permissions={permissions} page="dashboard">
          <Dashboard />
        </AppLayout>
      </Route> : ''}
      {hasPermission('periodo') ? <Route path={Helpers.config.convertUrl({ url: '/periodo' })} exact>
        <AppLayout title="Listado De Periodos" permissions={permissions} page="periodo">
          <Period nameSingle={Helpers.string.toCamelCase('Periodo')} namePlural={Helpers.string.toCamelCase('Periodos')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ecommerce') /* && parseInt(store.session.username) === 1 */ ? <Route path={Helpers.config.convertUrl({ url: '/ecommerce' })} exact>
        <AppLayout hideTop title="Tienda En Línea" permissions={permissions} page="ecommerce">
          <Ecommerce />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ecommerce') /* && parseInt(store.session.username) === 1 */ ? <Route path={Helpers.config.convertUrl({ url: '/carrito/:type?' })} exact>
        <AppLayout hideTop title="Carrito" permissions={permissions} page="ecommerce">
          <Cart />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ecommerce') /* && parseInt(store.session.username) === 1 */ ? <Route path={Helpers.config.convertUrl({ url: '/pago-realizado' })} exact>
        <AppLayout hideTop title="Carrito" permissions={permissions} page="ecommerce">
          <PaymentSuccess />
        </AppLayout>
      </Route> : ''}
      {hasPermission('informacion-personal') ? <Route path={Helpers.config.convertUrl({ url: '/informacion-personal' })} exact>
        <AppLayout hideTop title="Información Personal" permissions={permissions} page="informacion-personal">
          <PersonalInformation />
        </AppLayout>
      </Route> : ''}
      {hasPermission('mi-cuenta') ? <Route path={Helpers.config.convertUrl({ url: '/mi-cuenta' })} exact>
        <AppLayout hideTop title="Mi Cuenta" permissions={permissions} page="mi-cuenta">
          <DashboardAccount />
        </AppLayout>
      </Route> : ''}
      {hasPermission('descendia-de-red') ? <Route path={Helpers.config.convertUrl({ url: '/descendia-de-red' })} exact>
        <AppLayout hideTop title="Descendencia de Red" permissions={permissions} page="descendia-de-red">
          <Red />
        </AppLayout>
      </Route> : ''}
      {hasPermission('mi-equipo') ? <Route path={Helpers.config.convertUrl({ url: '/mi-equipo' })} exact>
        <AppLayout hideTop title="Descendencia de Red" permissions={permissions} page="mi-equipo">
          <Red />
        </AppLayout>
      </Route> : ''}
      {hasPermission('comisiones') ? <Route path={Helpers.config.convertUrl({ url: '/comisiones' })} exact>
        <AppLayout hideTop title="Comisiones" permissions={permissions} page="comisiones">
          <Commissions />
        </AppLayout>
      </Route> : ''}
      {hasPermission('detalle-de-comisiones') ? <Route path={Helpers.config.convertUrl({ url: '/detalle-de-comisiones' })} exact>
        <AppLayout title="Detalle de Comisiones" permissions={permissions} page="detalle-de-comisiones">
          <Commissions type="admin" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('historial-compras') ? <Route path={Helpers.config.convertUrl({ url: '/historial-compras' })} exact>
        <AppLayout hideTop title="Historial de Compras" permissions={permissions} page="historial-compras">
          <HistorySale />
        </AppLayout>
      </Route> : ''}
      {hasPermission('limites') ? <Route path={Helpers.config.convertUrl({ url: '/limites' })} exact>
        <AppLayout title="Límites" permissions={permissions} page="limites">
          <Limit nameSingle={Helpers.string.toCamelCase('Límite')} namePlural={Helpers.string.toCamelCase('Límites')} separator={'el'.toLowerCase()} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('comisiones-periodo') ? <Route path={Helpers.config.convertUrl({ url: '/comisiones-periodo' })} exact>
        <AppLayout title="Comisiones por periódo" permissions={permissions} page="comisiones-periodo">
          <CommisonsPeriod />
        </AppLayout>
      </Route> : ''}
      {hasPermission('historial-comisiones') ? <Route path={Helpers.config.convertUrl({ url: '/historial-comisiones' })} exact>
        <AppLayout hideTop title="Historial de Comisiones" permissions={permissions} page="historial-comisiones">
          <HistoryCommisions />
        </AppLayout>
      </Route> : ''}
      {hasPermission('puntos-periodo') ? <Route path={Helpers.config.convertUrl({ url: '/puntos-periodo' })} exact>
        <AppLayout title="Puntos por periódo" permissions={permissions} page="puntos-periodo">
          <PointPeriod />
        </AppLayout>
      </Route> : ''}
      {hasPermission('perfiles') ? <Route path={Helpers.config.convertUrl({ url: '/perfiles' })} exact>
        <AppLayout title="Perfiles" permissions={permissions} page="perfiles">
          <Profile namePlural="Perfiles" nameSingle="Perfil" separator="el" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('trabajadores') ? <Route path={Helpers.config.convertUrl({ url: '/trabajadores' })} exact>
        <AppLayout title="Trabajadores" permissions={permissions} page="trabajadores">
          <Worker namePlural="Trabajadores" nameSingle="Trabajador" separator="el" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('paridades') ? <Route path={Helpers.config.convertUrl({ url: '/paridades' })} exact>
        <AppLayout title="Paridades" permissions={permissions} page="paridades">
          <Exchange namePlural="Paridades" nameSingle="Paridad" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('promociones') ? <Route path={Helpers.config.convertUrl({ url: '/promociones' })} exact>
        <AppLayout title="Promociones" permissions={permissions} page="promociones">
          <Promo namePlural="Promociones" nameSingle="Promoción" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('copia-productos') ? <Route path={Helpers.config.convertUrl({ url: '/copia-productos' })} exact>
        <AppLayout title="Copia de Productos" permissions={permissions} page="copia-productos">
          <CopyProducts />
        </AppLayout>
      </Route> : ''}
      {hasPermission('imagenes-sistema') ? <Route path={Helpers.config.convertUrl({ url: '/imagenes-sistema' })} exact>
        <AppLayout title="Imagenes del Sistema" permissions={permissions} page="imagenes-sistema">
          <ImagesSystem />
        </AppLayout>
      </Route> : ''}
      {hasPermission('cerrar-periodo') ? <Route path={Helpers.config.convertUrl({ url: '/cerrar-periodo' })} exact>
        <AppLayout title="Cerrar Periodo" permissions={permissions} page="cerrar-periodo">
          <ClosePeriod />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ventas-totales-sucursal') ? <Route path={Helpers.config.convertUrl({ url: '/ventas-totales-sucursal' })} exact>
        <AppLayout title="Ventas Totales por Sucursal" permissions={permissions} page="ventas-totales-sucursal">
          <SaleTotalBranchOffice />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ventas-producto-cantidad-precio') ? <Route path={Helpers.config.convertUrl({ url: '/ventas-producto-cantidad-precio' })} exact>
        <AppLayout title="Ventas Producto Cantidad y Precio" permissions={permissions} page="ventas-producto-cantidad-precio">
          <SaleProductsQtyPrice />
        </AppLayout>
      </Route> : ''}
      {hasPermission('clientes-nuevos') ? <Route path={Helpers.config.convertUrl({ url: '/clientes-nuevos' })} exact>
        <AppLayout title="Clientes Nuevos" permissions={permissions} page="clientes-nuevos">
          <CustomersNew />
        </AppLayout>
      </Route> : ''}
      {hasPermission('mis-clientes-nuevos') ? <Route path={Helpers.config.convertUrl({ url: '/mis-clientes-nuevos' })} exact>
        <AppLayout hideTop title="Clientes Nuevos" permissions={permissions} page="mis-clientes-nuevos">
          <MyCustomersNew />
        </AppLayout>
      </Route> : ''}
      {hasPermission('descendencia-de-red') ? <Route path={Helpers.config.convertUrl({ url: '/descendencia-de-red' })} exact>
        <AppLayout title="Descendencia de Red" permissions={permissions} page="descendencia-de-red">
          <ReporteRed />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ventas-por-cliente') ? <Route path={Helpers.config.convertUrl({ url: '/ventas-por-cliente' })} exact>
        <AppLayout title="Ventas por Cliente" permissions={permissions} page="ventas-por-cliente">
          <ReporteSaleCustomers />
        </AppLayout>
      </Route> : ''}
      {hasPermission('configurar-archivos') ? <Route path={Helpers.config.convertUrl({ url: '/configurar-archivos' })} exact>
        <AppLayout title="Configurar Archivos" permissions={permissions} page="configurar-archivos">
          <File namePlural="Archivos" nameSingle="Archivo" separator="el" typeModule={1} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('archivos') ? <Route path={Helpers.config.convertUrl({ url: '/archivos' })} exact>
        <AppLayout title="Archivos" permissions={permissions} page="archivos">
          <FilePublic typeModule={1} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('corte-caja-usuario') ? <Route path={Helpers.config.convertUrl({ url: '/corte-caja-usuario' })} exact>
        <AppLayout title="Corte de Caja por Usuario" permissions={permissions} page="corte-caja-usuario">
          <BreakBoxUser />
        </AppLayout>
      </Route> : ''}
      {hasPermission('corte-caja-sucursal') ? <Route path={Helpers.config.convertUrl({ url: '/corte-caja-sucursal' })} exact>
        <AppLayout title="Corte de Caja por Sucursal" permissions={permissions} page="corte-caja-sucursal">
          <BreakBoxBranchOffice />
        </AppLayout>
      </Route> : ''}
      {hasPermission('direcciones-envio') ? <Route path={Helpers.config.convertUrl({ url: '/direcciones-envio' })} exact>
        <AppLayout title="Direcciones de Envío" permissions={permissions} page="direcciones-envio">
          <CustomersAddress namePlural="Direcciones de Envío" nameSingle="Dirección de Envío" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('tipos-de-despacho') ? <Route path={Helpers.config.convertUrl({ url: '/tipos-de-despacho' })} exact>
        <AppLayout title="Tipos de Despacho" permissions={permissions} page="tipos-de-despacho">
          <Dispatch namePlural="Tipos de Despacho" nameSingle="Tipo de Despacho" separator="el" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('puntos-de-clientes') ? <Route path={Helpers.config.convertUrl({ url: '/puntos-de-clientes' })} exact>
        <AppLayout title="Reporte de Puntos de Clientes" permissions={permissions} page="puntos-de-clientes">
          <CustomersPoint />
        </AppLayout>
      </Route> : ''}
      {hasPermission('listado-clientes') ? <Route path={Helpers.config.convertUrl({ url: '/listado-clientes' })} exact>
        <AppLayout title="Listado de Clientes" permissions={permissions} page="listado-clientes">
          <CustomersList />
        </AppLayout>
      </Route> : ''}
      {hasPermission('registrar-cliente') ? <Route path={Helpers.config.convertUrl({ url: '/registrar-cliente' })} exact>
        <AppLayout hideTop title="Registrar Cliente" permissions={permissions} page="registrar-cliente">
          <SaveMyCustomers />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ubicaciones') ? <Route path={Helpers.config.convertUrl({ url: '/ubicaciones' })} exact>
        <AppLayout title="Ubicaciones" permissions={permissions} page="ubicaciones">
          <PalletStock namePlural="Ubicaciones" nameSingle="Ubicación" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('roll-over') ? <Route path={Helpers.config.convertUrl({ url: '/roll-over' })} exact>
        <AppLayout hideTop title="Roll Over" permissions={permissions} page="roll-over">
          <RollOver />
        </AppLayout>
      </Route> : ''}
      {hasPermission('bonos') ? <Route path={Helpers.config.convertUrl({ url: '/bonos' })} exact>
        <AppLayout title="Bonos de suscripción" permissions={permissions} page="bonos">
          <CustomersBono />
        </AppLayout>
      </Route> : ''}
      {hasPermission('bonos-periodo') ? <Route path={Helpers.config.convertUrl({ url: '/bonos-periodo' })} exact>
        <AppLayout title="Bonos por periodo" permissions={permissions} page="bonos-periodo">
          <PeriodBono />
        </AppLayout>
      </Route> : ''}
      {hasPermission('historial-rango') ? <Route path={Helpers.config.convertUrl({ url: '/historial-rango' })} exact>
        <AppLayout title="Historial Rango" permissions={permissions} page="historial-rango">
          <CustomersHistoryPlan />
        </AppLayout>
      </Route> : ''}
      {hasPermission('configurar-escuela-tonic-club') ? <Route path={Helpers.config.convertUrl({ url: '/configurar-escuela-tonic-club' })} exact>
        <AppLayout title="Configurar Archivos Tonic Club" permissions={permissions} page="configurar-escuela-tonic-club">
          <File namePlural="Archivos" nameSingle="Archivo" separator="el" typeModule={2} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('escuela-tonic-club') ? <Route path={Helpers.config.convertUrl({ url: '/escuela-tonic-club' })} exact>
        <AppLayout title="Escuela Tonic Club" permissions={permissions} page="escuela-tonic-club">
          <FilePublic typeModule={2} />
        </AppLayout>
      </Route> : ''}
      {hasPermission('kardex') ? <Route path={Helpers.config.convertUrl({ url: '/kardex' })} exact>
        <AppLayout title="Kardex" permissions={permissions} page="kardex">
          <Kardex />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-inventario') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-inventario' })} exact>
        <AppLayout title="Reporte Inventario" permissions={permissions} page="reporte-inventario">
          <ReporteInventario />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-pago-clientes') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-pago-clientes' })} exact>
        <AppLayout title="Reporte Pago Clientes" permissions={permissions} page="reporte-pago-clientes">
          <CustomerPaid />
        </AppLayout>
      </Route> : ''}
      {hasPermission('mis-pagos') ? <Route path={Helpers.config.convertUrl({ url: '/mis-pagos' })} exact>
        <AppLayout title="Mis Pagos" permissions={permissions} page="mis-pagos">
          <HistoryPaid />
        </AppLayout>
      </Route> : ''}
      {hasPermission('cliente-dashboard') ? <Route path={Helpers.config.convertUrl({ url: '/cliente-dashboard' })} exact>
        <AppLayout title="Cliente Dashboard" permissions={permissions} page="cliente-dashboard">
          <Dashboard idCustomersFilter />
        </AppLayout>
      </Route> : ''}
      {hasPermission('cliente-promos') ? <Route path={Helpers.config.convertUrl({ url: '/cliente-promos' })} exact>
        <AppLayout title="Clientes Promos" permissions={permissions} page="cliente-promos">
          <CustomersPromo />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-producto') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-producto' })} exact>
        <AppLayout title="Reporte por Producto" permissions={permissions} page="reporte-producto">
          <ReportePromos />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-bono-cedea') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-bono-cedea' })} exact>
        <AppLayout title="Reporte CEDEA" permissions={permissions} page="reporte-bono-cedea">
          <ReporteCedea />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-bono-cedea-cliente') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-bono-cedea-cliente' })} exact>
        <AppLayout title="Reporte CEDEA" permissions={permissions} page="reporte-bono-cedea-cliente">
          <ReporteCedea />
        </AppLayout>
      </Route> : ''}
      {hasPermission('guias-de-rastreo') ? <Route path={Helpers.config.convertUrl({ url: '/guias-de-rastreo' })} exact>
        <AppLayout title="Guías de Rastreo" permissions={permissions} page="guias-de-rastreo">
          <SaleTracker namePlural="Guías de Rastreo" nameSingle="Guía de Rastreo" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-ventas') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-ventas' })} exact>
        <AppLayout title="Reporte de Ventas" permissions={permissions} page="reporte-ventas">
          <ReporteVentas />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-ecommerce-publico') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-ecommerce-publico' })} exact>
        <AppLayout title="Reporte Ecommerce Público" permissions={permissions} page="reporte-ecommerce-publico">
          <ReporteEcommercePublico />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-por-clave') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-por-clave' })} exact>
        <AppLayout title="Reporte por Clave de Producto" permissions={permissions} page="reporte-por-clave">
          <ReporteProductoClave />
        </AppLayout>
      </Route> : ''}
      {hasPermission('encuesta-1') ? <Route path={Helpers.config.convertUrl({ url: '/encuesta-1' })} exact>
        <AppLayout title="Encuesta 1" permissions={permissions} page="encuesta-1">
          <Encuesta1List namePlural="Encuestas" nameSingle="Encuesta" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('encuesta-2') ? <Route path={Helpers.config.convertUrl({ url: '/encuesta-2' })} exact>
        <AppLayout title="Encuesta 2" permissions={permissions} page="encuesta-2">
          <Encuesta2List namePlural="Encuestas" nameSingle="Encuesta" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('facturama-global') ? <Route path={Helpers.config.convertUrl({ url: '/facturama-global' })} exact>
        <AppLayout title="Factura Global" permissions={permissions} page="facturama-global">
          <FacturamaGlobal />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-piezas-no-producidas') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-piezas-no-producidas' })} exact>
        <AppLayout title="Piezas no producidas" permissions={permissions} page="reporte-piezas-no-producidas">
          <ReportePiezasNoProducidas />
        </AppLayout>
      </Route> : ''}
      {hasPermission('factura-libre') ? <Route path={Helpers.config.convertUrl({ url: '/factura-libre' })} exact>
        <AppLayout title="Factura Libre" permissions={permissions} page="factura-libre">
          <FacturaLibre />
        </AppLayout>
      </Route> : ''}
      {hasPermission('solicitud-viaticos') ? <Route path={Helpers.config.convertUrl({ url: '/solicitud-viaticos' })} exact>
        <AppLayout title="Viáticos" permissions={permissions} page="solicitud-viaticos">
          <Viaticos namePlural="Solicitud de Viáticos" nameSingle="Solicitud de Viático" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('aprobacion-viaticos') ? <Route path={Helpers.config.convertUrl({ url: '/aprobacion-viaticos' })} exact>
        <AppLayout title="Viáticos" permissions={permissions} page="aprobacion-viaticos">
          <ViaticosAll namePlural="Solicitud de Viáticos" nameSingle="Solicitud de Viático" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('facturama-folio') ? <Route path={Helpers.config.convertUrl({ url: '/facturama-folio' })} exact>
        <AppLayout title="Reporte Facturama Folio" permissions={permissions} page="facturama-folio">
          <ReporteFacturamaFolio />
        </AppLayout>
      </Route> : ''}
      {hasPermission('reporte-detallado-periodo') ? <Route path={Helpers.config.convertUrl({ url: '/reporte-detallado-periodo' })} exact>
        <AppLayout title="Reporte Detallado Periodo" permissions={permissions} page="reporte-detallado-periodo">
          <ReporteDetalladoPeriodo />
        </AppLayout>
      </Route> : ''}
      {hasPermission('suscripciones') ? <Route path={Helpers.config.convertUrl({ url: '/suscripciones' })} exact>
        <AppLayout title="Mis Suscripciones" permissions={permissions} page="suscripciones">
          <Susbcriptions />
        </AppLayout>
      </Route> : ''}
      {hasPermission('corte-de-caja-diario') ? <Route path={Helpers.config.convertUrl({ url: '/corte-de-caja-diario' })} exact>
        <AppLayout title="Corte de caja diario" permissions={permissions} page="corte-de-caja-diario">
          <BreakBoxUserDaily />
        </AppLayout>
      </Route> : ''}
      {hasPermission('bot-leads') ? <Route path={Helpers.config.convertUrl({ url: '/bot-leads' })} exact>
        <AppLayout title="Bot Leads" permissions={permissions} page="bot-leads">
          <BotLeads />
        </AppLayout>
      </Route> : ''}
      {hasPermission('bot-preorders') ? <Route path={Helpers.config.convertUrl({ url: '/bot-preorders' })} exact>
        <AppLayout title="Pre-órdenes del Bot" permissions={permissions} page="bot-preorders">
          <BotPreOrders />
        </AppLayout>
      </Route> : ''}
      {hasPermission('asistencia') ? <Route path={Helpers.config.convertUrl({ url: '/asistencia' })} exact>
        <AppLayout title="Asistencia" permissions={permissions} page="asistencia">
          <Attendance />
        </AppLayout>
      </Route> : ''}
      {hasPermission('asistencia-reporte') ? <Route path={Helpers.config.convertUrl({ url: '/asistencia-reporte' })} exact>
        <AppLayout title="Reporte Asistencia" permissions={permissions} page="asistencia-reporte">
          <EmployeeReport />
        </AppLayout>
      </Route> : ''}
      {hasPermission('rrhh-trabajadores') ? <Route path={Helpers.config.convertUrl({ url: '/rrhh-trabajadores' })} exact>
        <AppLayout title="Trabajadores" permissions={permissions} page="rrhh-trabajadores">
          <Employee namePlural="Trabajadores" nameSingle="Trabajador" separator="el" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('proveedores') ? <Route path={Helpers.config.convertUrl({ url: '/proveedores' })} exact>
        <AppLayout title="Proveedores" permissions={permissions} page="proveedores">
          <Supplier namePlural="Proveedores" nameSingle="Proveedor" separator="el" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('ordenes-compra') ? <Route path={Helpers.config.convertUrl({ url: '/ordenes-compra' })} exact>
        <AppLayout title="Órdenes de Compra" permissions={permissions} page="ordenes-compra">
          <SupplierRequest namePlural="Órdenes de Compra" nameSingle="Orden de Compra" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('campamento-de-lideres') ? <Route path={Helpers.config.convertUrl({ url: '/campamento-de-lideres' })} exact>
        <AppLayout title="Campamento de Líderes" permissions={permissions} page="campamento-de-lideres">
          <CampamentoLideres namePlural="Campamento de Líderes" nameSingle="Campamento de Líderes" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('subes-de-rango') ? <Route path={Helpers.config.convertUrl({ url: '/subes-de-rango' })} exact>
        <AppLayout title="Subes de Rango" permissions={permissions} page="subes-de-rango">
          <RankUp namePlural="Subes de Rango" nameSingle="Subes de Rango" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('pago-servicios') ? <Route path={Helpers.config.convertUrl({ url: '/pago-servicios' })} exact>
        <AppLayout title="Pago de Servicios" permissions={permissions} page="pago-servicios">
          <ServicePayment namePlural="Pagos de Servicios" nameSingle="Pago de Servicio" separator="el" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('solicitar-vacaciones') ? <Route path={Helpers.config.convertUrl({ url: '/solicitar-vacaciones' })} exact>
        <AppLayout title="Solicitar Vacaciones" permissions={permissions} page="solicitar-vacaciones">
          <Vacation namePlural="Solicitar Vacaciones" nameSingle="Solicitar Vacación" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('aprobar-vacaciones') ? <Route path={Helpers.config.convertUrl({ url: '/aprobar-vacaciones' })} exact>
        <AppLayout title="Aprobar Vacaciones" permissions={permissions} page="aprobar-vacaciones">
          <VacationApprove namePlural="Aprobar Vacaciones" nameSingle="Aprobar Vacación" separator="la" />
        </AppLayout>
      </Route> : ''}
      {hasPermission('campanas-sms') ? <Route path={Helpers.config.convertUrl({ url: '/campanas-sms' })} exact>
        <AppLayout title="Campañas SMS" permissions={permissions} page="campanas-sms">
          <SmsCampaign namePlural="Campañas SMS" nameSingle="Campaña SMS" separator="la" />
        </AppLayout>
      </Route> : ''}
      <Route path={Helpers.config.convertUrl({ url: '/login' })} exact>
        <Redirect to={Helpers.config.convertUrl({ url: '/' + homePage })} />
      </Route>
      <Route path={Helpers.config.convertUrl({ url: '/login/empresariosindependientes' })} exact>
        <Redirect to={Helpers.config.convertUrl({ url: '/' + homePage })} />
      </Route>
      <Route path={Helpers.config.convertUrl({ url: '/' })} exact>
        <Redirect to={Helpers.config.convertUrl({ url: '/' + homePage })} />
      </Route>
      <Route>
        <AppLayout title="No existe la página" permissions={permissions} showBread={false}>
          <NotFound backUrl="/" imageNotFound={Helpers.config.resourcesUrl({ url: '/images/dashboard/not-found.png' })} />
        </AppLayout>
      </Route>
    </Switch>
  </BrowserRouter>
}

Routes.defaultProps = {
  type: 'session'
}

export default Routes
